/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Form, Input, message, Row } from "antd";
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import {
  emailPattern,
  FormItemRequiredRule,
  UserPasswordRequiredRule,
} from "Utility/Constants";
import AuthContainer from "./AuthContainer";
import { API, Auth } from "aws-amplify";
import { decrypt, encrypt, generateUUID } from "Utility/Common/Methods";

function Register() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [isLoading, setIsLoading] = useState(false);
  const [userNameErrorMsg, setUserNameErrorMsg] = useState("");
  const [userNameValidateStatus, setUserNameValidateStatus] = useState("");
  const createBtnDisable =
    userNameValidateStatus === "error" ||
    userNameValidateStatus === "validating";

  const handleSubmit = async (data) => {
    console.log(
      encrypt(JSON.stringify(data), process.env?.REACT_APP_SECUTRY_KEY)
    );
    console.log(
      decrypt(
        encrypt(JSON.stringify(data), process.env?.REACT_APP_SECUTRY_KEY),
        process.env?.REACT_APP_SECUTRY_KEY
      )
    );

    setIsLoading(true);

    try {
      const res = await Auth.signUp({
        username: data.email,
        password: data.password,
        attributes: {
          email: data.email,
          preferred_username: userName,
          profile: "false",
        },
        autoSignIn: {
          enabled: true,
        },
      });
      console.log(res);
      localStorage.setItem(
        "cache",
        encrypt(JSON.stringify(data), process.env?.REACT_APP_SECUTRY_KEY)
      );
      navigate("/confirm-signup", {
        state: { email: data?.email, password: data?.password },
      });
    } catch (err) {
      console.log(err);
      let errorMessage =
        err?.code === "UsernameExistsException"
          ? "Looks like you already have an account, click 'Already an user?'"
          : err?.message;
      message.error(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  const [userName, setuserName] = useState(null);

  useEffect(() => {
    if (params.get("username")) {
      const username = replaceSpecialChars(params.get("username"));

      setuserName(username);
    }
  }, [params]);

  useEffect(() => {
    if (userName) {
      validateUserName(userName);
    }
  }, [userName]);

  function replaceSpecialChars(str) {
    return String(str)
      .replace(/[^a-zA-Z0-9-]/g, "-")
      .toLowerCase(); // Keeps letters, numbers, spaces, and hyphens
  }

  const validateUserName = async () => {
    if (uuid1 !== uuid2) {
      return;
    }

    let value = userName;
    //null value
    if (!value || value?.length === 0) {
      setUserNameValidateStatus("error");
      setUserNameErrorMsg("Please enter your username!");
      return;
    }

    //check other character
    const validUserNameRegex = /^[a-z0-9_-]+$/;
    if (!validUserNameRegex.test(value)) {
      setUserNameValidateStatus("error");
      setUserNameErrorMsg(
        "Username can only contain lowercase letters, numbers, underscores (_), and hyphens (-)"
      );
      return;
    }

    //
    if (value) {
      setUserNameValidateStatus("validating");
      setUserNameErrorMsg("");
      try {
        const data = await API.get("REST", `/company?name=${value}&check=true`);
        if (data?.isUserNameAvailable) {
          setUserNameValidateStatus("error");
          setUserNameErrorMsg("username already taken!");
        } else {
          setUserNameValidateStatus("success");
          setUserNameErrorMsg("");
        }
      } catch (error) {
        setUserNameValidateStatus("error");
        setUserNameErrorMsg("Username validation failed!");
      }
    }
  };

  const [uuid1, setuuid1] = useState();
  const [uuid2, setuuid2] = useState();

  useEffect(() => {
    setTimeout(() => {
      setuuid2(uuid1);
    }, 500);
  }, [uuid1]);

  useEffect(() => {
    if (uuid2) validateUserName();
  }, [uuid2]);

  return (
    <AuthContainer type={"register"}>
      <Form
        onFinish={handleSubmit}
        layout="vertical"
        requiredMark={false}
        name="login"
        initialValues={{ remember: true }}
        className="space-y-6 login-register-form"
      >
        <Form.Item
          hasFeedback
          validateStatus={userNameValidateStatus}
          help={userNameErrorMsg}
        >
          <Input
            placeholder="Claim your unique username"
            onChange={(e) => {
              let name = replaceSpecialChars(e.target.value);
              setuserName(name);
              setuuid1(generateUUID());
            }}
            value={userName}
            className={`p-2 rounded-md input-border`}
          />
        </Form.Item>

        <Form.Item
          name={"email"}
          rules={[
            FormItemRequiredRule,
            { pattern: emailPattern, message: "Please enter a proper email" },
          ]}
        >
          <Input
            placeholder="Email Address"
            className={"p-2 rounded-md input-border"}
          />
        </Form.Item>
        <Form.Item
          name={"password"}
          rules={[FormItemRequiredRule, UserPasswordRequiredRule]}
        >
          <Input.Password
            placeholder="Create a secret password"
            className="p-2 rounded-md input-border"
          />
        </Form.Item>

        <Form.Item>
          <Row justify={"center"}>
            <Button
              htmlType="submit"
              type="primary"
              className="w-full rounded-lg"
              loading={isLoading}
              disabled={createBtnDisable}
            >
              Create Account
            </Button>
          </Row>
        </Form.Item>
      </Form>

      <div className="text-center">
        <Link to="/login" className="text-sm hover:underline">
          Already an user?
        </Link>
      </div>
    </AuthContainer>
  );
}
export default Register;
